import axios from 'axios';
import Api from "../config/Api";
import { setUserSession } from "../Utils/Common";

class UploadFilesService {
    upload(file, defaultSelectedType, formData, onUploadProgress) {
        let formBodyData = new FormData();
        console.log(defaultSelectedType)
        console.log(formData)
        formBodyData.append("files", file);
        if( defaultSelectedType === 'Project' )
        {
            formBodyData.append("projectId", formData.projectId);
        }

        return Api().post(`files?type=${defaultSelectedType}`, formBodyData, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
            onUploadProgress,
        });
    }

    getFiles() {
        let fileList = Api().get("files/all");
        return fileList;
    }
}

export default new UploadFilesService();